import { computed } from 'vue';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';

export const useCurrentUserLevel = () => {
  const store = useCurrentUserStore();

  const isDomainUser = computed(() => store.enabled && store.level === UserLevel.DOMAIN);
  const isTenantUser = computed(() => store.enabled && store.level === UserLevel.TENANT);
  const isOrganisationUser = computed(() => store.enabled && store.level === UserLevel.ORGANISATION);
  const isDomainOrTenantUser = computed(() => isDomainUser.value || isTenantUser.value);

  return { isDomainUser, isTenantUser, isOrganisationUser, isDomainOrTenantUser };
};
